import { Control, ControlType } from './control';
import { Option } from './option';

export class SelectControl extends Control<string> {
  private readonly initialValue?: string;

  constructor(
    name: string,
    placeholder: string,
    public options: Option[],
    value?: string
  ) {
    super(name, placeholder, ControlType.select, value || name);
    this.initialValue = name;
  }

  isValid(): boolean {
    return this.required ? this.value !== this.initialValue : true;
  }
}
